import { createContext, useState, useEffect, useContext } from 'react';
import { AccountContext } from './account-context';
import { SocketContext } from './socket-context';
import { getAccount, getAccounts } from '../common/api-requests';
import { ErrorContext } from './error-context'

const RecipientsContext = createContext();

const RecipientsProvider = ({ children }) => {

    const [account, setAccount] = useContext(AccountContext);
    const [stateAccount, setStateAccount] = useState(account);
    const [socket, setSocket] = useContext(SocketContext);
    const [recipients, setRecipients] = useState([]);
    const [error, setError] = useContext(ErrorContext);

    useEffect(() => {
        setStateAccount(account);
    }, [account]);

    useEffect(() => {

        if (!stateAccount)
            return;

        getAccounts().then((accounts) => {

            if (accounts && accounts.length) {
                accounts = accounts.sort(function (a, b) {
                    const dateA = a.lastMessage ? new Date(a.lastMessage.ondate) : new Date(0);
                    const dateB = b.lastMessage ? new Date(b.lastMessage.ondate) : new Date(0);
                    return dateB - dateA;
                });

                setRecipients(accounts);
            }
        })
            .catch((errorInner) => {
                setError("(" + errorInner.status + ")" + " " + errorInner.text);
            });

    }, [stateAccount]);


    useEffect(() => {

        if (!socket)
            return;

        if (socket.type == 4) {

            if (socket.action == 1) {

                if (!recipients.some(a => a.id == socket.id)) {

                    getAccount(socket.id).then((recipient) => {

                        if (recipient) {

                            recipient.status = 1;

                            setRecipients(prevRecipients => {

                                let updRecipients = [...prevRecipients, recipient];

                                updRecipients = updRecipients.sort(function (a, b) {
                                    const dateA = a.lastMessage ? new Date(a.lastMessage.ondate) : new Date(0);
                                    const dateB = b.lastMessage ? new Date(b.lastMessage.ondate) : new Date(0);
                                    return dateB - dateA;
                                });

                                return updRecipients;
                            });
                        }
                    });
                }
            }
            else if (socket.action == 3) {
                setRecipients(prevRecipients => {
                    let updRecipients = [...prevRecipients].filter(a => a.id != socket.id);
                    return updRecipients;
                });
            }
        }
        else if (socket.type == 1) {

            if (!socket.isTask) {

                let index = recipients.findIndex(a => a.id == socket.recipientAccountID || a.id == socket.senderAccountID);

                if (index == -1)
                    return;

                setRecipients(prevRecipients => {

                    let updRecipients = [...prevRecipients];

                    let newMessages = [...updRecipients[index].newMessages];

                    if (socket.senderAccountID != account.id && !newMessages.some(a => a.id == socket.id) && socket.action === 1) {
                        newMessages.push(socket.id);
                    }

                    updRecipients[index] = { ...updRecipients[index], status: 1, newMessages: newMessages, lastMessage: { text: socket.text, ondate: socket.ondate } };

                    updRecipients = updRecipients.sort(function (a, b) {
                        const dateA = a.lastMessage ? new Date(a.lastMessage.ondate) : new Date(0);
                        const dateB = b.lastMessage ? new Date(b.lastMessage.ondate) : new Date(0);
                        return dateB - dateA;
                    });

                    return updRecipients;
                });

            }
        }

    }, [socket]);

    return (
        <RecipientsContext.Provider value={[recipients, setRecipients]}>
            {children}
        </RecipientsContext.Provider>
    )
}

export { RecipientsContext, RecipientsProvider };